<template>
   <el-dialog title="" :visible.sync="showBlock" :close-on-click-modal="false" width="450px" :before-close="closedBtn">
      <div class="warp-input">
         <el-form :model="ruleForm" status-icon  ref="ruleForm" label-width="80px" class="demo-ruleForm">
            <div class="common-relatives">
               <el-form-item label="原密码" prop="oldPassword">
                  <el-input v-model="ruleForm.oldPassword" placeholder="请输入原密码"  :clearable="true"></el-input>
               </el-form-item>
               <div class="text" v-if="popoldPassword">原密码不可为空</div>
            </div>
            <div class="common-relatives">
               <el-form-item label="新密码" prop="passWord">
                  <el-input type="password" v-model="ruleForm.passWord" placeholder="请输入6~12位密码" maxlength="12" autocomplete="off" :clearable="true"></el-input>
               </el-form-item>
               <div class="text" v-if="poppassword">{{passwordText}}</div>
            </div>
            <div class="common-relatives">
               <el-form-item label="确认密码" prop="checkPass">
                  <el-input type="password" v-model="ruleForm.checkPass" placeholder="再次输入密码" autocomplete="off" :clearable="true"></el-input>
               </el-form-item>
               <div class="text" v-if="popcheckPass">{{checkPassText}}</div>
            </div>
            <div class="common-relatives">
               <el-form-item>
                  <div class="warp-BTN">
                     <el-button @click="closedBtn">取消</el-button>
                     <el-button type="primary" @click="submitBtn">确定</el-button>
                  </div>
               </el-form-item>
            </div>
         </el-form>
      </div>
   </el-dialog>
</template>
<script>

import {url,rules,operate} from '@/utils/config';
import {putFun} from '@/utils/httpFun'
import { hex_md5 } from '@/utils/md5';
export default {
   data() {
      return {
         showBlock: false,
         ruleForm: {
            oldPassword: '',
            passWord: '',
            checkPass: '',
         },
         popoldPassword:false,
        
         poppassword:false,
         passwordText:"",

         popcheckPass:false,
         checkPassText:"",
      };
   },
   methods: {

      //开启弹窗
      showBlockM() {
         this.showBlock = true
         this.popoldPassword = false
         this.poppassword = false
         this.popcheckPass = false
         this.ruleForm={
            oldPassword: '',
            passWord: '',
            checkPass: '',
         }
      },
      //关闭弹窗
      closedBtn() {
         this.showBlock = false

      },

      //验证旧密码
      validationOldPassword(){
          if(!rules.NONEMPTY.test(this.ruleForm.oldPassword)){
             this.popoldPassword = true
             return false
          }
          this.popoldPassword = false
          return true
      },
      //验证用新密码
      validationPassweord(){

         let rule  = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;

         if(!rule.test(this.ruleForm.passWord)){
            this.poppassword = true
             this.passwordText = "密码格式错误 6-12位字母加数字"
             return false
         }

         if(!rules.NONEMPTY.test(this.ruleForm.passWord)){
             this.poppassword = true
             this.passwordText = "新密码不可为空"
             return false
          }
          this.poppassword = false
          return true
      },

      //验证重复密码
      validationRev(){
        if(!rules.NONEMPTY.test(this.ruleForm.checkPass)){
               this.popcheckPass = true
               this.checkPassText = "确认密码不可为空"
               return false
        }

        if(this.ruleForm.passWord!=this.ruleForm.checkPass){
             this.popcheckPass = true
             this.checkPassText = "两次密码不一致"
             return false
        }
        this.popcheckPass = false
        this.checkPassText = ""
        return true
      },

     async submitBtn() {
         let oldP = this.validationOldPassword()
         let newP = this.validationPassweord()
         let reP = this.validationRev()
         let validation = oldP && newP && reP
         if(!validation){
             return
         }
         let parms = {
            oldPassword:hex_md5(this.ruleForm.oldPassword),
            password:hex_md5(this.ruleForm.passWord),
            loginType:1
         }
        
         await putFun(operate.PERSONALPWORUPDATA,parms,res=>{
            if(res.code==1){
               this.$router.replace({path:"/", query:{}})
               this.$message({
                  message: '密码修改成功',
                  type: 'success'
               });
               this.showBlock = false
               
            } 
         })
      }
   }
}
</script>
<style lang="scss" scoped>
    .warp-BTN{
       display: flex;
       justify-content: flex-end;
    }
    .warp-input{
       position: relative;
       
    }
    .text{
         position: absolute;
         bottom:-20px;
         left:80px;
         font-size: 12px;
         color: #e6a23c;
      }
</style>